import { useCallback, useContext } from "react";
import {
  useCancelAbsenceRequests,
  useIsAbsenceRequestActionPending,
} from "src/Pages/Company/Absences/api/absenceRequests.queries";
import { GlobalModalContext } from "src/utils/GlobalModal/GlobalModalContext";
import __ from "src/utils/Translations";
import { useModalActionsPending } from "src/utils/hooks/absences/useModalActionsPending";

export const useConfirmCancellation = () => {
  const { setModal, resetModal } = useContext(GlobalModalContext);

  const { mutate: cancelAbsenceRequest } = useCancelAbsenceRequests();

  const isPending = useIsAbsenceRequestActionPending();
  const modalId = useModalActionsPending(isPending);

  const confirmCancellation = useCallback(
    (absenceRequestId: string, name: string, eTag: string) => {
      if (typeof setModal === "function") {
        setModal({
          id: modalId,
          open: true,
          disableOutsideClick: isPending,
          disableExitButton: isPending,
          title: <>{__("Czy na pewno chcesz anulować wniosek?")}</>,
          description: __(
            `Po anulowaniu wniosku "${name}" nie będzie możliwości, aby go przywrócić.`
          ),
          actions: [
            {
              label: __("Wyjdź"),
              variant: "outlined",
              disabled: isPending,
              callbackFn: () => {
                resetModal();
              },
            },
            {
              label: __("Anuluj wniosek"),
              variant: "contained",
              color: "error",
              disabled: isPending,
              callbackFn: () => {
                resetModal();
                cancelAbsenceRequest({ absenceRequestId, eTag });
              },
            },
          ],
        });
      }
    },
    [cancelAbsenceRequest, isPending, modalId, resetModal, setModal]
  );

  return { confirmCancellation };
};
